export default __webpack_public_path__ + "static/media/24.b13feaed.jpg";